import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface HeroProps {
  component: Component
  locale: LocaleCode
  style: React.CSSProperties
}

export function Hero({ component, locale, style }: HeroProps) {
  const config = component.config as any
  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const buttonText = getLocalizedText(config.buttonText, locale)
  const buttonHref = config.buttonHref
  const backgroundImage = config.backgroundImage
  const textAlignment = config.textAlignment || 'center'
  const minHeight = config.minHeight || '400px'

  const alignmentMap = {
    left: 'items-start text-left',
    center: 'items-center text-center',
    right: 'items-end text-right',
  }
  const alignmentClass = alignmentMap[textAlignment as keyof typeof alignmentMap] || 'items-center text-center'

  const heroStyle: React.CSSProperties = {
    ...style,
    minHeight,
  }

  // Only set background image properties if there's an image (preserves gradient from style)
  if (backgroundImage) {
    heroStyle.backgroundImage = `url(${backgroundImage})`
    heroStyle.backgroundSize = 'cover'
    heroStyle.backgroundPosition = 'center'
  }

  // Extract text color from style if present
  const textColor = style.color

  return (
    <div style={heroStyle} className={cn('flex flex-col justify-center px-8 py-10', alignmentClass)}>
      {title && (
        <h1 className="text-5xl font-bold mb-4 max-w-3xl" style={{ color: textColor }}>
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="text-xl mb-6 max-w-2xl" style={{ color: textColor }}>
          {subtitle}
        </p>
      )}
      {buttonText && (
        <a
          href={buttonHref || '#'}
          className="inline-block px-8 py-3 bg-primary text-primary-foreground no-underline rounded font-bold hover:opacity-90 transition-opacity"
        >
          {buttonText}
        </a>
      )}
    </div>
  )
}
